import loadable from '@loadable/component';

export const LoadableCreateNewProjectDrawer = loadable(
	() => import(/* webpackChunkName: "create-new-project-drawer" */ './create-new-project-drawer.component'),
	{
		resolveComponent: ({ CreateNewProjectDrawer }) => CreateNewProjectDrawer
	}
);
